import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-617e2d9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-drawer__panel-content" }
const _hoisted_2 = { class: "tir-pm-drawer__panel-content-inner" }

import { computed, CSSProperties } from "vue";
import { TirPmDrawerPositionEnum } from "./enums";
import { TirPmScrollbar } from "tir-pm-scrollbar";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmDrawer',
  props: {
    visible: { type: Boolean, default: false },
    size: { default: "auto" },
    position: { default: TirPmDrawerPositionEnum.Left },
    overlayClass: { default: "" },
    panelClass: { default: "" }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }) {

const props = __props;





const style = computed<CSSProperties>(() => {
  const isHorizontal = [
    TirPmDrawerPositionEnum.Top,
    TirPmDrawerPositionEnum.Bottom,
  ].includes(props.position);

  const isVertical = [
    TirPmDrawerPositionEnum.Left,
    TirPmDrawerPositionEnum.Right,
  ];

  return {
    width: isVertical ? props.size : "",
    height: isHorizontal ? props.size : "",
  };
});

const close = () => {
  emit("update:visible", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "overlay" }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['tir-pm-drawer__overlay', _ctx.overlayClass]),
              onClick: close
            }, null, 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "panel" }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tir-pm-drawer__panel", [`position--${_ctx.position}`, _ctx.panelClass]]),
              style: _normalizeStyle(style.value)
            }, [
              _renderSlot(_ctx.$slots, "content", { close: close }, () => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(TirPmScrollbar), { style: {"height":"100%","max-height":"100%"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default", { close: close })
                      ])
                    ]),
                    _: 3
                  })
                ])
              ])
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})